export default __webpack_public_path__ + "static/media/header2.f719ba94.jpg";